import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const TableChart = ({ data, config, title }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  if (!data || data.length === 0) {
    return <div className="text-sand-700 p-8 text-center">No data available</div>;
  }

  const columns = Object.keys(data[0]);
  const totalPages = Math.ceil(data.length / itemsPerPage);
  const startIdx = (currentPage - 1) * itemsPerPage;
  const endIdx = startIdx + itemsPerPage;
  const pageData = data.slice(startIdx, endIdx);

  const formatValue = (value) => {
    if (typeof value === 'number') {
      return value.toLocaleString(undefined, {
        maximumFractionDigits: 2,
        minimumFractionDigits: 0
      });
    }
    return String(value);
  };

  return (
    <div className="space-y-4">
      {title && <h3 className="text-ink font-semibold text-lg">{title}</h3>}

      <div className="overflow-x-auto bg-white rounded-lg border border-[rgba(32,30,29,0.12)]">
        <table className="w-full">
          <thead>
            <tr className="border-b border-[rgba(32,30,29,0.12)]">
              {columns.map((col) => (
                <th
                  key={col}
                  className="px-4 py-3 text-left text-sand-700 font-semibold text-sm"
                >
                  {col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {pageData.map((row, rowIdx) => (
              <tr key={rowIdx} className="border-b border-[rgba(32,30,29,0.08)] hover:bg-sand-100 transition-colors">
                {columns.map((col) => (
                  <td
                    key={`${rowIdx}-${col}`}
                    className="px-4 py-3 text-sand-700 text-sm tnum"
                  >
                    {formatValue(row[col])}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <div className="flex items-center justify-between">
          <p className="text-sand-700 text-sm">
            Page {currentPage} of {totalPages} ({data.length} rows)
          </p>
          <div className="flex gap-2">
            <button
              onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
              disabled={currentPage === 1}
              className="p-2 rounded-lg bg-white border border-[rgba(32,30,29,0.18)] text-ink disabled:opacity-50 disabled:cursor-not-allowed hover:bg-sand-100 transition-colors"
            >
              <ChevronLeft className="w-4 h-4" />
            </button>
            <button
              onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
              disabled={currentPage === totalPages}
              className="p-2 rounded-lg bg-white border border-[rgba(32,30,29,0.18)] text-ink disabled:opacity-50 disabled:cursor-not-allowed hover:bg-sand-100 transition-colors"
            >
              <ChevronRight className="w-4 h-4" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TableChart;
